import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Section } from "@/components/ui/section";
import { Container } from "@/components/ui/container";
import { BrandButton } from "@/components/ui/brand-button";
import Seo from "@/components/Seo";
import { PAGE_META } from "@/lib/seo-constants";

export default function NotFound() {
    return (
        <Section dark className="py-28 md:py-36 min-h-[60vh]" data-testid="notfound-page">
            <Seo {...PAGE_META.notFound} path="/404" noindex />
            <Container>
                <div className="max-w-2xl">
                    <p className="text-xs uppercase tracking-[0.3em] text-brand-coral font-semibold mb-4">
                        Error 404
                    </p>
                    <h1
                        className="font-display text-6xl sm:text-7xl lg:text-8xl tracking-wide leading-none text-white"
                        data-testid="notfound-title"
                    >
                        Page Not Found
                    </h1>
                    <p className="mt-6 text-white/70 max-w-lg">
                        The page you were looking for doesn't exist — but our team is
                        still ready to build whatever you have in mind.
                    </p>
                    <div className="mt-8 flex flex-col sm:flex-row gap-3">
                        <BrandButton asChild variant="primary" size="lg">
                            <Link to="/" data-testid="notfound-home-cta">
                                <ArrowLeft className="h-4 w-4" strokeWidth={2.25} />
                                Back Home
                            </Link>
                        </BrandButton>
                        <BrandButton asChild variant="outline" tone="onDark" size="lg">
                            <Link to="/contact">Contact Us</Link>
                        </BrandButton>
                    </div>
                </div>
            </Container>
        </Section>
    );
}
